import {
    Outlet,
    useParams,
    useSearchParams,
} from "react-router-dom";
import { getUserLang, isNullOrEmpty } from "../../lib/helper";
import { useInjectedService } from "../../services/ioc/service-dependency";
import { Icon } from "@fluentui/react/lib/Icon";
import { Dropdown } from "@fluentui/react/lib/Dropdown";

import "./bootstrap.min.css";
import "./layout.css";

const Layout = (props: { pathname: string }) => {
    const { localizationService } = useInjectedService();
    let { culture } = useParams();
    let { location } = useParams();
    if (!isNullOrEmpty(culture) && culture !== undefined) {
        localizationService.setLanguage(culture, props.pathname);
    }
    const [searchParams] = useSearchParams();

    if (isNullOrEmpty(culture) || culture === undefined) {
        culture = getUserLang(props.pathname);
    }

    let homeUrl = "/";
    let recommendedAppsUrl = "";
    let pdfCulture = "en";
    if (
        !isNullOrEmpty(culture) &&
        culture !== undefined &&
        localizationService.isValidCulture(culture, props.pathname)
    ) {
        homeUrl = "/" + culture;
        recommendedAppsUrl = "/" + culture;
        pdfCulture = culture;
    }

    if (
        !isNullOrEmpty(location) &&
        location !== undefined &&
        localizationService.isValidCountry(location)
    ) {
        homeUrl += "/" + location;
        recommendedAppsUrl += "/" + location;
    }

    homeUrl += window.location.search;
    recommendedAppsUrl += "/recommended" + window.location.search;

    var headerMaxHeight = 113;
    window.onscroll = function () {
        var header = document.querySelector("header");
        if (header !== null) {
            var currentScrollPos = window.scrollY;
            if (currentScrollPos > headerMaxHeight && window.innerWidth >= 1280) {
                header.classList.add("is-compressed");
            } else {
                header.classList.remove("is-compressed");
            }
        }
    };

    if (document !== undefined) {
        document.title = localizationService.getLocalizedText("WelcomeTitle");
    }

    const toggleNav = function () {
        var nav = document.querySelector(".bbraun-nav");
        if (nav !== null) {
            if (!nav.classList.contains("is-expanded")) {
                nav.classList.add("is-expanded");
            } else {
                nav.classList.remove("is-expanded");
            }
        }
    };

    let href = "";
    if (
        !isNullOrEmpty(window) &&
        !isNullOrEmpty(window.location) &&
        !isNullOrEmpty(window.location.href)
    ) {
        href = window.location.href;
    }

    const welcomeNavLinkActive =
        href.indexOf("recommended") === -1 &&
        href.indexOf("prepare") === -1 &&
        href.indexOf("faq") === -1 &&
        href.indexOf("terms-of-use") === -1 &&
        href.indexOf("privacy-policy") === -1;
    // &&
    // href.indexOf("bkcapp") === -1

    let languageOptions = localizationService.supportedCultures.map((l) => {
        let include = true;
        if ((props.pathname.indexOf("bkcapp") !== -1 && !l.includeInBkcAppPage) ||
            (props.pathname.indexOf("bkcapp") === -1 && !l.includeInGetStartedPage)) {
            include = false;
        }
        return {
            text: localizationService.getLocalizedText(l.translationKey),
            key: l.key,
            include: include
        };
    });
    languageOptions.sort((a, b) => {
        if (a.text < b.text) {
            return -1;
        }
        if (a.text > b.text) {
            return 1;
        }
        return 0;
    });

    let locationOptions = localizationService.supportedCountries.map((l) => {
        return {
            text: localizationService.getLocalizedText(l.translationKey),
            key: l.key,
        };
    });
    locationOptions.sort((a, b) => {
        if (a.text < b.text) {
            return -1;
        }
        if (a.text > b.text) {
            return 1;
        }
        return 0;
    });

    return (
        <div>
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css?family=Roboto:300,400,500"
            />
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
            ></link>
            <div className="bbraun-container">
                <header className="row bbraun-toprow">
                    <a href={homeUrl} rel="noreferrer" className="bbraun-logo">
                        <img
                            alt="BBraun_Logo"
                            src={require("../../assets/images/bbraunlogo.svg").default}
                            data-midwidth="800"
                            data-maxwidth="0"
                        />
                        <img
                            alt="BBraun_Logo"
                            src={require("../../assets/images/bbraunlogoshort.svg").default}
                            data-maxwidth="800"
                        />
                    </a>
                    <div>
                        <nav className="bbraun-nav">
                            <ul className="bbraun-nav-links">
                                {props.pathname.indexOf("bkcapp") === -1 && (
                                    <>
                                        <li>
                                            <a
                                                href={homeUrl}
                                                className={
                                                    welcomeNavLinkActive ? "bbraun-nav-link-active" : ""
                                                }
                                            >
                                                {localizationService.getLocalizedText("Welcome")}
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={recommendedAppsUrl}
                                                className={
                                                    href.indexOf("recommended") > -1
                                                        ? "bbraun-nav-link-active"
                                                        : ""
                                                }
                                            >
                                                {localizationService.getLocalizedText(
                                                    "RecommendedApps"
                                                )}
                                            </a>
                                        </li>
                                    </>
                                )}
                                {props.pathname.indexOf("bkcapp") > -1 && (
                                    <>
                                        <li>
                                            <a
                                                className="bbraun-faq-link"
                                                target="_blank"
                                                rel="noreferrer"
                                                href={require("../../assets/files/FAQ_2025_" +
                                                    pdfCulture +
                                                    ".pdf")}
                                            >
                                                <Icon
                                                    className="bbraun-faq-icon"
                                                    iconName="Help"
                                                />
                                                {localizationService.getLocalizedText("FAQ")}
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href={require("../../assets/files/BKCApp_Onepager_" +
                                                    pdfCulture +
                                                    ".pdf")}
                                            >
                                                <Icon
                                                    className="bbraun-language-icon"
                                                    iconName="Info"
                                                />
                                                {localizationService.getLocalizedText("PrivateUsage")}
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </nav>
                    </div>
                    <div className="bbraun-language">
                        <Dropdown
                            onRenderTitle={(item) => {
                                if (item !== undefined) {
                                    return (
                                        <div>
                                            <Icon className="bbraun-language-icon" iconName="Globe" />
                                            <span className="bbraun-language-text">
                                                {item[0].text}
                                            </span>
                                        </div>
                                    );
                                }
                                return null;
                            }}
                            className="bbraun-language-dropdown"
                            selectedKey={
                                culture && localizationService.isValidCulture(culture, props.pathname)
                                    ? culture
                                    : getUserLang(props.pathname)
                            }
                            onChange={(e, l) => {
                                if (l !== undefined) {
                                    let pathSplit = window.location.pathname.split("/");
                                    pathSplit = pathSplit.filter((p) => !isNullOrEmpty(p));
                                    if (pathSplit.length > 0) {
                                        let newPath = "/" + l.key;
                                        pathSplit.forEach((p) => {
                                            if (!localizationService.isValidCulture(p, props.pathname)) {
                                                newPath += "/" + p;
                                            }
                                        });
                                        window.location.href = newPath + window.location.search;
                                    } else {
                                        window.location.href = "/" + l.key + window.location.search;
                                    }
                                }
                            }}
                            options={languageOptions.filter(l => l.include)}
                        />
                    </div>
                    {(searchParams.get("showlocationselection") === "true" ||
                        searchParams.get("showlocationselection") === "1") && (
                            <div className="bbraun-location">
                                <Dropdown
                                    onRenderPlaceholder={() => {
                                        return (
                                            <div>
                                                <Icon
                                                    className="bbraun-location-icon"
                                                    iconName="MapPin"
                                                />
                                                <span className="bbraun-location-text">
                                                    {localizationService.getLocalizedText("Location")}
                                                </span>
                                            </div>
                                        );
                                    }}
                                    onRenderTitle={(item) => {
                                        if (item !== undefined) {
                                            return (
                                                <div>
                                                    <Icon
                                                        className="bbraun-location-icon"
                                                        iconName="MapPin"
                                                    />
                                                    <span className="bbraun-location-text">
                                                        {item[0].text}
                                                    </span>
                                                </div>
                                            );
                                        }
                                        return null;
                                    }}
                                    className="bbraun-location-dropdown"
                                    selectedKey={
                                        location && localizationService.isValidCountry(location)
                                            ? location
                                            : "Location"
                                    }
                                    onChange={(e, l) => {
                                        if (l !== undefined) {
                                            var selectedCountry =
                                                localizationService.supportedCountries.filter(
                                                    (sL) => l.key === sL.key
                                                )[0];
                                            let pathSplit = window.location.pathname.split("/");
                                            pathSplit = pathSplit.filter((p) => !isNullOrEmpty(p));
                                            if (pathSplit.length > 0) {
                                                let newPath =
                                                    "/" + selectedCountry.defaultLanguageKey + "/" + l.key;
                                                pathSplit.forEach((p) => {
                                                    if (
                                                        !localizationService.isValidCountry(p) &&
                                                        p.length > 2
                                                    ) {
                                                        newPath += "/" + p;
                                                    }
                                                });
                                                window.location.href = newPath + window.location.search;
                                            } else {
                                                window.location.href =
                                                    "/" +
                                                    selectedCountry.defaultLanguageKey +
                                                    "/" +
                                                    l.key +
                                                    window.location.search;
                                            }
                                        }
                                    }}
                                    options={locationOptions}
                                />
                            </div>
                        )}
                    <Icon
                        onClick={() => toggleNav()}
                        className="bbraun-nav-expand-icon"
                        iconName="CollapseMenu"
                    />
                </header>
                <div className="bbraun-content-container">
                    <main role="main">
                        <Outlet />
                    </main>
                </div>
                <footer className="border-top footer text-muted">
                    <div className="bbraun-footer-left">
                        <nav>
                            <ul>
                                <li>
                                    <a
                                        rel="noreferrer"
                                        href={localizationService.getLocalizedText("InPrintLink")}
                                        target="_blank"
                                    >
                                        {localizationService.getLocalizedText("InPrintText")}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        rel="noreferrer"
                                        href={localizationService.getLocalizedText("PrivacyLink")}
                                        target="_blank"
                                    >
                                        {localizationService.getLocalizedText("PrivacyText")}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        rel="noreferrer"
                                        href="https://jira.bbraun.com/servicedesk/customer/portal/121"
                                        target="_blank"
                                    >
                                        {localizationService.getLocalizedText("HelpText")}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <div className="text-center bbraun-footer-right">
                        {localizationService.getLocalizedText("CopyrightText")}
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default Layout;
